/**
 * WebSocket 连接状态枚举
 */
export enum WebSocketState {
  /**
   * 尚未初始化
   */
  NOTINITIALIZED = -1,

  /**
   * 正在链接中
   */
  CONNECTING = 0,

  /**
   * 已经链接并且可以通讯
   */
  OPEN = 1,

  /**
   * 连接正在关闭
   */
  CLOSING = 2,

  /**
   * 连接已关闭或者没有链接成功
   */
  CLOSED = 3,
}

export type WebSocketError = {
  type: WebSocketErrorType;
  closeError?: WebSocketCloseError;
  target?: Event | CloseEvent;
  error?: any;
};

export enum WebSocketErrorType {
  Error = 'Error',
  Close = 'Close',
  MicroAuth = 'MicroAuth',
  DuplicateConnect = 'DuplicateConnect',
  IllegalURL = 'IllegalURL',
  Unknown = 'Unknown',
  IllegalArgs = 'IllegalArgs',
}

/**
 * WebSocket 异常关闭枚举：https://developer.mozilla.org/zh-CN/docs/Web/API/CloseEvent。
 */
export enum WebSocketCloseError {
  /**
   * 正常关闭; 无论为何目的而创建，该链接都已成功完成任务。
   */
  Err_1000 = 'CLOSE_NORMAL',
  /**
   * 终端离开, 可能因为服务端错误, 也可能因为浏览器正从打开连接的页面跳转离开。
   */
  Err_1001 = 'CLOSE_GOING_AWAY',

  /**
   * 由于协议错误而中断连接。
   */
  Err_1002 = 'CLOSE_PROTOCOL_ERROR',

  /**
   * 由于接收到不允许的数据类型而断开连接 (如仅接收文本数据的终端接收到了二进制数据)。
   */
  Err_1003 = 'CLOSE_UNSUPPORTED',

  /**
   * 安全因素或WebSocket连接次数达到上限。
   */
  Err_1006 = 'CLOSE_ABNORMAL',

  /**
   * 由于收到了格式不符的数据而断开连接 (如文本消息中包含了非 UTF-8 数据)。
   */
  Err_1007 = 'Unsupported Data',
  /**
   * 由于收到不符合约定的数据而断开连接。
   */
  Err_1008 = 'Policy Violation',
  /**
   * 由于收到过大的数据帧而断开连接。
   */
  Err_1009 = 'CLOSE_TOO_LARGE',
  /**
   * 未知错误。
   */
  Err_unknown = 'unknown',
}

export function parseWSClsErr(code: number) {
  switch (code) {
    case 1000: {
      return WebSocketCloseError.Err_1000;
    }
    case 1001: {
      return WebSocketCloseError.Err_1001;
    }
    case 1002: {
      return WebSocketCloseError.Err_1002;
    }
    case 1003: {
      return WebSocketCloseError.Err_1003;
    }
    case 1006: {
      return WebSocketCloseError.Err_1006;
    }
    case 1007: {
      return WebSocketCloseError.Err_1007;
    }
    case 1008: {
      return WebSocketCloseError.Err_1008;
    }
    case 1009: {
      return WebSocketCloseError.Err_1009;
    }
    default:
      break;
  }

  return WebSocketCloseError.Err_unknown;
}
